import * as _ from 'lodash';
import build from 'redux-object';

export const partnerSelectors = {
  getPartners: (state) => {
    const rawPartners = state.data.meta['/api/v3/my/partners']?.data || [];
    const partnerIds = rawPartners.map((partner) => partner.id);
    const partners = build(state.data, 'partners') || [];

    return _.sortBy(
      partners.filter((partner) => partnerIds.includes(partner.id)),
      'name'
    );
  },

  getMeta: (state) => state.data.meta['/api/v3/my/partners']?.meta || { totalPages: 0, totalCount: 0 },
};
